import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Navigation from "@/components/Navigation/Navigation";
import ModalDialog from "@/components/ModalDialog/ModalDialog";
import ScheduleHeader from "@/components/ScheduleComponents/ScheduleHeader/ScheduleHeader";
import ScheduleTable from "@/components/ScheduleComponents/ScheduleTable/ScheduleTable";
import ScheduleAppointmentInfo from "@/components/ScheduleComponents/ScheduleAppointmentInfo/ScheduleAppointmentInfo";
import ToothFormulaScreen from "@/components/ToothFormulaScreen/ToothFormulaScreen";
import { fetchSchedule } from "@/store/schedule/scheduleSlice";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import useDeleteEntity from "@/hooks/useDeleteEntity";
import formattedDate from "@/utils/formattedDate";
import { RootState } from "@/store/store";
import { resetExistAppointmentData } from "@/store/appointments/appointmentsSlice";
import { setIsVisibleModalDialog } from "@/store/ui/ui";
import { deleteAppointment } from "@/store/schedule/scheduleSlice";

import "@/shared/styles/layout.scss";
import "./SchedulePage.scss";

export default function SchedulePage() {
    const [open, setOpen] = useState<boolean>(false);
    const dispatch = useDispatch();
    const appDispatch = useAppDispatch();
    const { handleDelete } = useDeleteEntity();

    function toggleDrawer(isOpen: boolean): void {
        setOpen(isOpen);
    }
    const appointmentInfo = useSelector(
        (state: RootState) => state.appointments.existtAppointment,
    );
    const isVisibleModalDialog = useSelector(
        (state: RootState) => state.ui.isVisibleModalDialog,
    );

    const { _id, patientId, date } = appointmentInfo;
    const patientName = patientId.name;

    useEffect(() => {
        let flag = true;
        if (flag && !open && !isVisibleModalDialog) {
            dispatch(resetExistAppointmentData());
            flag = false;
        }
    }, [open, dispatch, isVisibleModalDialog]);

    function onSuccess() {
        dispatch(deleteAppointment(_id));
        dispatch(resetExistAppointmentData());
        dispatch(setIsVisibleModalDialog(false));
    }

    async function handleDeleteAppointment() {
        await handleDelete({
            entity: "appointments",
            id: _id ?? "",
            onSuccess: onSuccess,
            message: "Візит пацієнта успішно видалено",
            isLocalLoading: true,
        });
    }

    useEffect(() => {
        appDispatch(fetchSchedule());
    }, [appDispatch]);

    return (
        <div className='container'>
            <Navigation />
            <div className='main_content main_contetnt_in_shedule_page'>
                <ScheduleHeader />
                <ScheduleTable toggleDrawer={toggleDrawer} open={open} />
                <ScheduleAppointmentInfo
                    toggleDrawer={toggleDrawer}
                    open={open}
                />
                <ToothFormulaScreen />
                <ModalDialog
                    onConfirm={() => handleDeleteAppointment()}
                    title='Видалити візит пацієнта?'
                    message={`Ви впевнені, що хочете видалити візит ${patientName} запланований на ${formattedDate(
                        date,
                    )}`}
                    onCansel={() => dispatch(resetExistAppointmentData())}
                />
            </div>
        </div>
    );
}
